import React, { useState, useEffect } from "react";
import { fromJS } from "immutable";
import { connect } from "react-redux";
import { Form, Field, reduxForm, destroy } from "redux-form";
import { ToastContainer, toast } from "react-toastify";
import VerifyMobile from "../../components/salesUser/campaign/verifymobilejs";
import "react-toastify/dist/ReactToastify.css";
import {
  InputContact,
  DropDownContact,
  DropDown,
  DropDownContactDistrict,
} from "../common/input";
import { getState } from "../../action/user_action";
import Footer from "../common/Footer";
import { scrollHandler, goToByScroll } from "../../util/animation";
import Header from "../common/Header";
import { axiosInstnace as Axios } from "../../util/util";
import { endPoints } from "../../config";
import { history } from "../../history/history";
import {
  phoneNumber,
  email,
  string,
  maxLengthCheck,
} from "../../util/validate";
import AOS from "aos";

import Popup from "react-popup";

const DSAContact = (props) => {
  //Define the initial state.
  const [name, setName] = useState("");
  const [stateList, handleCityState] = useState([]);
  const [cityList, handleCity] = useState([]);

  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [state, setState] = useState("")
  const [city, setCity] = useState("")
  const [verify, setVerify] = useState(false);

  //Initialize the scroll function
  useEffect(() => {
    window.addEventListener("scroll", scrollHandler);
    props.getState();
    AOS.init({
      duration: 600,
    });
    return () => {
      window.removeEventListener("scroll", scrollHandler);
    };
  }, []);

  useEffect(() => {
    if (props.stateList && props.stateList.size > 0) {
      console.log(props.stateList.size);
      console.log(props.stateList[props.stateList.size]);
      props.stateList[props.stateList.size] = "Outside India";
      console.log(props.stateList);
      let stateList = props.stateList.toJS().map((s) => ({
        name: s,
        value: s,
      }));
      handleCityState(fromJS(stateList));
    }
  }, [props.stateList]);

  const handleArrowChange = (e) => {
    console.log(e.target.value);
    handleStateCity(e.target.value);
    setState(e.target.value)
  };
  const handleStateCity = async (state) => {
    const response = await Axios.get(`${endPoints.getCities}?state=${state}`);
    console.log(response.data.data.data);
    let cityList = response.data.data.data;
    handleCityItems(cityList);
  };

  const handleCityItems = (cityList) => {
    let cityListItems = cityList.map((d) => ({
      name: d.city,
      value: d.city,
    }));
    console.log(cityListItems);
    handleCity(fromJS(cityListItems));
  };

  const handleverifypopup = () => {
    setVerify(!verify);
  };
  const verifymobile = (e) => {
    e.preventDefault();
    if (
      name.trim().length === 0 ||
      email.trim().length === 0 ||
      mobile.trim().length === 0 || !state || !city
    ) {
      toast.error("All Fields are mandatory", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1",
      });
      return;
    }
    if (!mobile.match(/^[6789]\d{9}$/)) {
      toast.error("Please enter a valid Phone Number", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1",
      });
      return;
    }
    if (
      !email.match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )
    ) {
      toast.error("Please enter a valid email address", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1",
      });
      return;
    }
    if (email.trim().endsWith("radiobigfm.com")) {
      toast.error(
        "radiobigfm users are not allowed to SIGN UP as Trade Partner",
        {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: false,
          hideProgressBar: true,
          toastId: "1",
        }
      );
      return;
    }
    setVerify(!verify);
  };
  /**
   * Submit the contact form that
   * containing the info object about the contact.
   */
  const handleSubmit = async () => {
    setVerify(!verify);
    let params = {
      email,
      name,
      mobile,
      state,
      city
    };
    try {
      const data = await Axios.post(endPoints.dsasignup, params);
      const result = data.data;
      if (result) {
        props.destroyForm("contact");
        toast.error(result.message, {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: false,
          hideProgressBar: true,
          toastId: "1",
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  //Return the contact text
  return (
    <div className="main_wrapper contact-wrapper">
      <Header active={true} withoutSticky={true} />
      <div class="contactus_top" style={{padding:'10% 16% 13% 9%',textAlign:"center", color:"white", fontWeight:"bold", fontSize:"20px"}}
    >
    <p>Why you should become a trade partner with us ?</p>
    <div  style={{textAlign:"left", marginLeft:"33%", lineHeight:"2rem"}}>
    <p>- Earn attractive incentives</p>
    <p>- Hassle free , paperless process</p>
    <p>- Automated &amp; timely incentives
    </p>
    <p>- End to end audio production process online
    </p>
    <p>- Quick turn around / time to market</p>
</div>
</div><div className="contactus_bottom_wrapper">
        <div className="contactus_form_wrapper">
          <div className="contact_header">
            <div className="contactgrid-img">
              <img src="../../assets/images/dots.png" />
            </div>
            <div className="contact_card_text">
              <div className="text_innerdsaagent">BECOME Trade Partner</div>
            </div>
          </div>
          <div className="form_wrapper">
            <p className="form_header">
              Submit your details to become Trade Partner (DIRECT SALES AGENT)
              Of BIGFM
            </p>
            <div className="contact_form">
              {/* <form className="contact_form"> */}
              <Form className="contact_form">
                <div className="form_left_wrapper">
                  <div className="form_left">
                    <div className="contact_field">
                      <div className="contact_label">
                        <label>Name</label>
                      </div>
                      <div className="contact_input">
                        {/* <input type="text" placeholder="Enter your name"/> */}
                        <Field
                          type="text"
                          name="name"
                          placeholder="Enter your name"
                          component={InputContact}
                          value={name}
                          onChange={(e) => {
                            setName(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="contact_field">
                      <div className="contact_label">
                        <label>Email Address</label>
                      </div>
                      <div className="contact_input">
                        {/* <input type="email" placeholder="Enter valid email id"/> */}
                        <Field
                          type="text"
                          name="email"
                          placeholder="Enter your email address"
                          component={InputContact}
                          value={email}
                          onChange={(e) => {
                            setEmail(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="contact_field">
                      <div className="contact_label">
                        <label>Mobile</label>
                      </div>
                      <div className="contact_input">
                        {/* <input type="text" placeholder="Enter your mobile number" /> */}
                        <Field
                          type="text"
                          name="mobile"
                          placeholder="Enter your mobile number"
                          component={InputContact}
                          value={mobile}
                          onChange={(e) => {
                            setMobile(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="contact_field">
                      <div className="contact_label">
                        <label>State</label>
                      </div>
                      <div className="contact_input">
                        <Field
                          type="text"
                          name="state"
                          label="State"
                          component={DropDownContact}
                          options={stateList}
                          onChange={handleArrowChange}
                        />
                      </div>
                    </div>
                    <div className="contact_field">
                      <div className="contact_label">
                        <label>City</label>
                      </div>
                      <div className="contact_input">
                        <Field
                          type="text"
                          name="city"
                          label="City"
                          component={DropDownContactDistrict}
                          options={cityList}
                          onChange={(e)=>{
                            setCity(e.target.value)
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="contact_submit">
                    <button onClick={verifymobile}>SUBMIT</button>
                  </div>
                </div>
              </Form>
            </div>
          </div>
          {verify && (
            <VerifyMobile
              hide={handleverifypopup}
              isShowing={true}
              mobile={mobile}
              verify={handleSubmit}
            />
          )}
        </div>
      </div>
      <Footer />
      <ToastContainer />
    </div>
  );
};

const mapStateToProps = (state) => ({ stateList: state.user.get("stateList") });

export default connect(mapStateToProps, { getState, destroyForm: destroy })(
  reduxForm({
    form: "contact",
  })(DSAContact)
);



// WEBPACK FOOTER //
// ./web/components/becomedsa/index.js